import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loginUser } from "../../store/slices/Auth/Login/thunk";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";
import { FaLock } from "react-icons/fa";
import { FiShield } from "react-icons/fi";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"; // Exact matching image verification check icon
import { Button } from "@mui/material";
import Spinner from "react-bootstrap/esm/Spinner";
import forcardbg from "../../assets/map.jpg";
import webimg from "../../assets/weblogo.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.height = "100%";
    document.body.style.overflow = "hidden";
    document.body.style.height = "100%";
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    return () => {
      document.documentElement.style.overflow = "";
      document.documentElement.style.height = "";
      document.body.style.overflow = "";
      document.body.style.height = "";
      document.body.style.margin = "";
      document.body.style.padding = "";
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result: any = await dispatch(loginUser(email, password));
      if (result.success) {
        navigate("/dashboard");
      } else {
        toast.error(result.message || "Login failed: Invalid email or password");
      }
    } catch (err: any) {
      toast.error("Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Root Layout Wrapper (Hidden overflow to prevent unwanted page scrolling) */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${forcardbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          fontFamily: "'Poppins', 'Segoe UI', sans-serif",
          padding: "15px",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        {/* White Center Card Container (Optimized height to prevent overflow) */}
        <div
          style={{
            width: "100%",
            maxWidth: "460px",
            backgroundColor: "#ffffff",
            borderRadius: "28px",
            boxShadow: "0px 24px 48px rgba(0, 0, 0, 0.15)",
            padding: "30px 35px 25px 35px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            boxSizing: "border-box",
            position: "relative",
          }}
        >
          {/* Top Right Dot Decoration */}
          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "30px",
              display: "grid",
              gridTemplateColumns: "repeat(5, 4px)",
              gap: "4px",
              opacity: 0.3,
            }}
          >
            {[...Array(25)].map((_, i) => (
              <span key={i} style={{ width: "4px", height: "4px", backgroundColor: "#888", borderRadius: "50%" }}></span>
            ))}
          </div>

          {/* Top Illustration/Logo (Sized optimally to fix the vertical height issue) */}
          <div style={{ marginBottom: "10px", textAlign: "center" }}>
            <img
              src={webimg}
              alt="Logo Illustration"
              style={{ height: "95px", width: "auto", objectFit: "contain" }}
            />
          </div>

          {/* Sub Header Content */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#94a3b8", fontSize: "12px", fontWeight: 500, marginBottom: "4px" }}>
            <span style={{ width: "16px", height: "1px", backgroundColor: "#cbd5e1" }}></span>
            <span>Welcome Back!</span>
            <span style={{ width: "16px", height: "1px", backgroundColor: "#cbd5e1" }}></span>
          </div>

          {/* Brand Heading (Using your requested standard colors) */}
          <h1 style={{ margin: "0 0 4px 0", fontSize: "32px", fontWeight: 700, letterSpacing: "-0.5px" }}>
            <span style={{ color: "#1976d2" }}>Van</span> <span style={{ color: "#1e293b" }}>Wala</span>
          </h1>

          {/* Tagline */}
          <p style={{ margin: "0 0 24px 0", fontSize: "12px", color: "#64748b", fontWeight: 500 }}>
            Smart. Reliable. Always <span style={{ color: "#1976d2", fontWeight: 600 }}>on the Move.</span>
          </p>

          {/* Login Action Form */}
          <form onSubmit={handleLogin} style={{ width: "100%", display: "flex", flexDirection: "column", gap: "14px" }}>
            
            {/* Email Field Wrapper */}
            <div style={{ width: "100%", position: "relative", display: "flex", alignItems: "center" }}>
              <div
                style={{
                  position: "absolute",
                  left: "14px",
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  backgroundColor: "#f0f7ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#1976d2",
                }}
              >
                <IoMdMail style={{ fontSize: "18px" }} />
              </div>
              <input
                type="email"
                placeholder="mukesh@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: "100%",
                  height: "50px",
                  paddingLeft: "64px",
                  paddingRight: "20px",
                  backgroundColor: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: "14px",
                  fontSize: "14px",
                  color: "#334155",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* Password Field Wrapper */}
            <div style={{ width: "100%", position: "relative", display: "flex", alignItems: "center" }}>
              <div
                style={{
                  position: "absolute",
                  left: "14px",
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  backgroundColor: "#f0f7ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#1976d2",
                }}
              >
                <FaLock style={{ fontSize: "14px" }} />
              </div>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: "100%",
                  height: "50px",
                  paddingLeft: "64px",
                  paddingRight: "45px",
                  backgroundColor: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: "14px",
                  fontSize: "14px",
                  color: "#334155",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              <span
                onClick={() => setShowPassword((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "16px",
                  cursor: "pointer",
                  color: "#94a3b8",
                  display: "flex",
                  alignItems: "center",
                  userSelect: "none",
                }}
              >
                {showPassword ? <IoEyeOff style={{ fontSize: "18px" }} /> : <IoEye style={{ fontSize: "18px" }} />}
              </span>
            </div>

            {/* Remember Me & Forgot Password Section */}
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "12px",
                fontWeight: 500,
                marginTop: "2px",
                marginBottom: "12px",
                padding: "0 2px",
                boxSizing: "border-box",
              }}
            >
              <label style={{ display: "flex", alignItems: "center", color: "#64748b", cursor: "pointer", userSelect: "none" }}>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  style={{
                    marginRight: "8px",
                    width: "15px",
                    height: "15px",
                    accentColor: "#1976d2",
                    cursor: "pointer",
                  }}
                />
                Remember me
              </label>
              {/* <span style={{ color: "#1976d2", cursor: "pointer", textDecoration: "none" }}>
                Forgot Password?
              </span> */}
            </div>

            {/* Action Submit Button (Restored original colors & features) */}
            <div style={{ width: "100%" }}>
              <Button
                type="submit"
                disabled={loading}
                variant="contained"
                style={{
                  width: "100%",
                  height: "50px",
                  backgroundColor: loading ? "#64b5f6" : "#1976d2",
                  borderRadius: "14px",
                  textTransform: "none",
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#ffffff",
                  boxShadow: "0px 6px 20px rgba(25, 118, 210, 0.25)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: "8px" }}
                    />
                    <span>Login...</span>
                  </>
                ) : (
                  <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                    <span>Login</span>
                    <span style={{ position: "absolute", right: "5px", fontSize: "18px", fontWeight: "300" }}>→</span>
                  </div>
                )}
              </Button>
            </div>
          </form>

          {/* Footer Verification Badges (Aligned perfectly with the layout image specs) */}
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "14px",
              color: "#64748b",
              fontSize: "12px",
              fontWeight: 500,
              marginTop: "25px",
              paddingTop: "15px",
              borderTop: "1px solid #f1f5f9",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <IoMdCheckmarkCircleOutline style={{ color: "#1976d2", fontSize: "16px" }} />
              <span>Secure</span>
            </div>
            <span style={{ width: "4px", height: "4px", backgroundColor: "#cbd5e1", borderRadius: "50%" }}></span>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <IoMdCheckmarkCircleOutline style={{ color: "#1976d2", fontSize: "16px" }} />
              <span>Reliable</span>
            </div>
            <span style={{ width: "4px", height: "4px", backgroundColor: "#cbd5e1", borderRadius: "50%" }}></span>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <IoMdCheckmarkCircleOutline style={{ color: "#1976d2", fontSize: "16px" }} />
              <span>Trusted</span>
            </div>
          </div>

        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default Login;